import {cloneElement, FocusEvent, ReactElement} from 'react';

export interface FocusToScrollProps {
  children: ReactElement;
}

const AVAILABLE_TARGETS = ['INPUT', 'TEXTAREA'];

function FocusToScroll({children}: FocusToScrollProps): JSX.Element {
  return cloneElement(children, {
    onFocus: (event: FocusEvent) => {
      if (children.props.onFocus) {
        children.props.onFocus(event);
      }
      if (AVAILABLE_TARGETS.includes(event.target.tagName.toUpperCase())) {
        setTimeout(() => {
          event.target.scrollIntoView({behavior: 'instant', block: 'start'});
        }, 300);
      }
    },
  });
}

export default FocusToScroll;
